module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/237bf42c437b2886b3e3097b078d6369.png";